var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('main-layout',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }